"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ViewLayout = exports.ViewLayoutDefaultProps = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var utils_1 = require("@shapeable/utils");
var slice_layout_1 = require("./slice-layout");
var entity_value_1 = require("./entity-value");
var cls = (0, utils_1.classNames)('view-layout');
exports.ViewLayoutDefaultProps = {};
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    background: ", ";\n    padding: ", ";\n    border: 1px solid ", ";\n    margin-bottom: ", ";\n    border-radius: ", ";\n  "], ["\n    background: ", ";\n    padding: ", ";\n    border: 1px solid ", ";\n    margin-bottom: ", ";\n    border-radius: ", ";\n  "])), theme_1.theme.COLOR('app-chrome'), theme_1.theme.UNIT(4), theme_1.theme.COLOR('line-subtle'), theme_1.theme.UNIT(3), theme_1.theme.UNIT(2))
});
var SliceLayoutStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    box-sizing: border-box;\n    border-radius: 2px;\n    margin: ", " 0 ", ";\n  "], ["\n    box-sizing: border-box;\n    border-radius: 2px;\n    margin: ", " 0 ", ";\n  "])), theme_1.theme.UNIT(4), theme_1.theme.UNIT(1))
});
var ValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var LinkedValueStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var HeadStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    display: flex;\n    justify-content: space-between;\n    gap: ", ";\n  "], ["\n    display: flex;\n    justify-content: space-between;\n    gap: ", ";\n  "])), theme_1.theme.UNIT(8))
});
var LinkedItemsStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n    justify-content: space-between;\n    display: flex; \n    gap: ", ";\n    padding-right: ", "; \n  "], ["\n    justify-content: space-between;\n    display: flex; \n    gap: ", ";\n    padding-right: ", "; \n  "])), theme_1.theme.UNIT(8), theme_1.theme.UNIT(4))
});
// -------- Components -------->
var My = {
  Container: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Head: styled_components_1.default.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), HeadStyles),
  Value: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), ValueStyles),
  LinkedItems: styled_components_1.default.div(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), LinkedItemsStyles),
  LinkedValue: (0, styled_components_1.default)(entity_value_1.EntityValue)(templateObject_11 || (templateObject_11 = __makeTemplateObject(["", ""], ["", ""])), LinkedValueStyles),
  Slice: (0, styled_components_1.default)(slice_layout_1.SliceLayout)(templateObject_12 || (templateObject_12 = __makeTemplateObject(["", ""], ["", ""])), SliceLayoutStyles)
};
var ViewLayout = function (props) {
  var className = props.className,
    children = props.children,
    entity = props.entity;
  var _a = entity.slices,
    slices = _a === void 0 ? [] : _a,
    layout = entity.layout,
    type = entity.type;
  var typeName = type && type.name;
  return react_1.default.createElement(My.Container, {
    className: cls.name(className)
  }, react_1.default.createElement(My.Head, null, react_1.default.createElement(My.Value, {
    label: "".concat(typeName ? "".concat(typeName, " View") : ''),
    showMenu: true,
    variant: 'default',
    entity: entity
  }), react_1.default.createElement(My.LinkedItems, null, layout && react_1.default.createElement(My.LinkedValue, {
    variant: 'small',
    entity: layout
  }), type && react_1.default.createElement(My.LinkedValue, {
    variant: 'small',
    entity: type
  }))), slices.map(function (slice, index) {
    return react_1.default.createElement(My.Slice, {
      entity: slice,
      key: slice.id,
      number: index + 1
    });
  }));
};
exports.ViewLayout = ViewLayout;
exports.ViewLayout.cls = cls;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10, templateObject_11, templateObject_12;